// extracted by mini-css-extract-plugin
export var actionButton = "_it-0";
export var fileInput = "_it-2";
export var paperclip = "_it-1";